export default "<app-pplus-checkbox [disabled]=\"true\" [value]=\"this.value\"></app-pplus-checkbox>"